import type { DownloadParams } from './types';

/**
 * 下载/导出方法
 * @param props 下载/导出参数
 */
export async function download(props: DownloadParams): Promise<void> {
  const { fileName, type } = props;

  let fileUrl: string | null = null;

  if (type === 'img') {
    fileUrl = props.url;
  }

  if (type === 'blob') {
    fileUrl = window.URL.createObjectURL(props.blob);
  }

  if (type === 'file') {
    const propName = props.method === 'POST' ? 'data' : 'params';

    const blob = await props.net.download<Blob>({
      url: props.url,
      method: props.method,
      [propName]: props.params
    });
    fileUrl = window.URL.createObjectURL(blob);
  }

  if (fileUrl == null) {
    /** TODO: 是否要抛出异常？ */
    return;
  }

  const link = document.createElement('a');
  link.href = fileUrl;

  link.setAttribute('download', `${fileName}`);
  document.body.appendChild(link);

  link.click();
  window.URL.revokeObjectURL(fileUrl);
  link.parentNode?.removeChild(link);
}
